














import { Component, Prop, Vue } from "vue-property-decorator";
import { CzOption } from "./types";
import CzChoice from "./CzChoice.vue";

@Component({ components: { CzChoice } })
export default class CzPills extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: CzOption[];
  @Prop({ default: null }) value!: any;
  @Prop({ type: Boolean, default: false }) wrap!: boolean;
}
